import { render, staticRenderFns } from "./PromotionDialog.vue?vue&type=template&id=1e088890&scoped=true"
import script from "./PromotionDialog.vue?vue&type=script&lang=js"
export * from "./PromotionDialog.vue?vue&type=script&lang=js"
import style0 from "./PromotionDialog.vue?vue&type=style&index=0&id=1e088890&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e088890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e088890')) {
      api.createRecord('1e088890', component.options)
    } else {
      api.reload('1e088890', component.options)
    }
    module.hot.accept("./PromotionDialog.vue?vue&type=template&id=1e088890&scoped=true", function () {
      api.rerender('1e088890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/components/PromotionDialog.vue"
export default component.exports